import { findBoundaryTime } from "utils/datesAndTimes/findBoundaryTime";

export function findEarliestTime(
	dates: Date[],
	midnightIsLate: boolean
): moment.Duration | undefined {
	return findBoundaryTime(dates, midnightIsLate, true);
}
